export var FeeCalculationBasis;
(function (FeeCalculationBasis) {
    FeeCalculationBasis["PICK_UP_DATE"] = "PICK_UP_DATE";
    FeeCalculationBasis["DAILY"] = "DAILY";
})(FeeCalculationBasis || (FeeCalculationBasis = {}));
